import { render, staticRenderFns } from "./hotSpot.vue?vue&type=template&id=27a66e81&scoped=true"
import script from "./hotSpot.vue?vue&type=script&lang=js"
export * from "./hotSpot.vue?vue&type=script&lang=js"
import style0 from "./hotSpot.vue?vue&type=style&index=0&id=27a66e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a66e81",
  null
  
)

export default component.exports